import { render, staticRenderFns } from "./WhatsappContato.vue?vue&type=template&id=7fd3b0ac&scoped=true&"
import script from "./WhatsappContato.vue?vue&type=script&lang=js&"
export * from "./WhatsappContato.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappContato.vue?vue&type=style&index=0&id=7fd3b0ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd3b0ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
